import { motion } from "framer-motion";

const GRID_EASE = [0.22, 1, 0.36, 1] as const;

export function LoadingState() {
  const vignetteColors = [
    "var(--vignette-color-1)",
    "var(--vignette-color-2)",
    "var(--vignette-color-3)",
    "var(--vignette-color-4)",
    "var(--vignette-color-5)",
    "var(--vignette-color-6)",
  ] as const;

  return (
    <motion.div
      animate={{ opacity: 1 }}
      className="flex w-full flex-col items-center justify-center py-24"
      initial={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: GRID_EASE }}
    >
      <video
        autoPlay
        className="size-20"
        loop
        muted
        onCanPlay={(e) => {
          e.currentTarget.playbackRate = 2;
        }}
        playsInline
        src="/bear_alpha_smooth.webm"
      />
      <div className="relative mt-8 h-1 w-32 overflow-hidden rounded-full bg-zinc-100 dark:bg-zinc-800">
        <motion.div
          animate={{
            x: ["-100%", "100%"],
          }}
          className="absolute inset-0 bg-linear-to-r from-transparent via-blue-500/50 to-transparent"
          transition={{
            duration: 1.5,
            repeat: Number.POSITIVE_INFINITY,
            ease: "easeInOut",
          }}
        />
        <motion.div
          animate={{
            backgroundColor: [...vignetteColors, vignetteColors[0]],
            opacity: [0.4, 1, 0.4],
          }}
          className="absolute inset-0"
          transition={{
            backgroundColor: {
              duration: 0.8,
              repeat: Number.POSITIVE_INFINITY,
              ease: "linear",
            },
            opacity: {
              duration: 2,
              repeat: Number.POSITIVE_INFINITY,
              ease: "easeInOut",
            },
          }}
        />
      </div>
    </motion.div>
  );
}
